
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [{"isolation":"isolate"},style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","style":"isolation:isolate","viewBox":"0 0 24 24","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"d":"M0 0h24v24H0z"}})])]),_c('g',{attrs:{"clip-path":"url(#a)"}},[_c('path',{attrs:{"d":"M17.367 17.392c-3.046 2.841-7.834 2.673-10.675-.373-2.84-3.045-2.673-7.834.373-10.674.872-.813 1.885-1.33 2.978-1.763-1.14 1.498-2.911 5.526.332 9.003 3.2 3.432 7.106 2.159 8.958.959-.327 1.034-1.094 2.035-1.966 2.848z"}})])])
          )
        }
      }
    